import { render, staticRenderFns } from "./LayoutProvider.vue?vue&type=template&id=041598a6&scoped=true&"
import script from "./LayoutProvider.vue?vue&type=script&lang=js&"
export * from "./LayoutProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041598a6",
  null
  
)

export default component.exports